/* =========================================================================
   CHARMANTE — Configurateur multi-produits (bandanas & bijoux à charms)
   Galerie de bases → (choix de la couleur si le produit a des variantes photo)
   → personnalisation avec charms (charms INCLUS) → ajout panier.
   3D (tilt) sur l'aperçu + rebond à la pose d'un charm.
   ========================================================================= */
(function () {
  'use strict';
  var root    = document.getElementById('czRoot');
  var gallery = document.getElementById('czGallery');
  var builder = document.getElementById('czBuilder');
  var picker  = document.getElementById('czPicker');
  if (!root || !gallery || !builder || !picker) return;

  var stage      = document.getElementById('czStage');
  var art        = document.getElementById('czArt');
  var slotsWrap  = document.getElementById('czSlots');
  var priceEl    = document.getElementById('czPrice');
  var placedEl   = document.getElementById('czPlaced');
  var countEl    = document.getElementById('czCount');
  var charmsWrap = document.getElementById('czCharms');
  var colorsWrap = document.getElementById('czColors');
  var colorNameEl= document.getElementById('czColorName');
  var colorStepEl= document.getElementById('czColorStep');
  var charmStepEl= document.getElementById('czCharmStep');
  var goBtn      = document.getElementById('czGo');
  var prevBtn    = document.getElementById('czPrev');
  var nextBtn    = document.getElementById('czNext');
  if (!stage || !art || !slotsWrap) return;

  /* ---- Catalogue de charms = VRAIES PHOTOS (injectées via #czCharmAssets) ---- */
  var CHARMS = {};        // slug -> { name, img, w, h }
  var CHARM_ORDER = [];   // ordre d'affichage dans la palette
  (function () {
    var s = document.getElementById('czCharmAssets');
    if (!s) return;
    try {
      var arr = JSON.parse(s.textContent) || [];
      arr.forEach(function (c) { if (c && c.slug) { CHARMS[c.slug] = { name: c.name, img: c.img, w: c.w, h: c.h, w_cm: c.w_cm, h_cm: c.h_cm, color: c.color, cats: c.cats || '', size: c.size || '' }; CHARM_ORDER.push(c.slug); } });
    } catch (e) {}
  })();
  var CAT_LABELS = { ocean: 'Océan 🐚', animaux: 'Animaux 🐢', coeur: 'Cœur 💗', nature: 'Nature 🌸', nourriture: 'Gourmand 🍓', cowboy: 'Cowboy 🤠', symbole: 'Symboles ✨' };
  var CAT_ORDER = ['ocean', 'animaux', 'coeur', 'nature', 'nourriture', 'cowboy', 'symbole'];
  var COLOR_ORDER = ['Rouge', 'Rose', 'Orange', 'Jaune', 'Vert', 'Turquoise', 'Bleu', 'Violet', 'Doré', 'Gris', 'Blanc', 'Noir', 'Multicolore'];
  var SIZE_ORDER = ['XS', 'S', 'M', 'L', 'XL'];
  var BANDANA_CM = 19;        // largeur réelle du bandana (cou), en cm
  var BANDANA_FRAC = 0.626;   // le bandana occupe ~62,6 % de la largeur de l'aperçu
  var CHARM_SCALE = 1.25;         // taille des charms posés — MOBILE
  var CHARM_SCALE_DESKTOP = 1.0;  // ORDINATEUR : charms un peu + petits vs bandana (demande cliente, desktop only)
  function charmScale() { return (window.matchMedia && matchMedia('(min-width: 900px)').matches) ? CHARM_SCALE_DESKTOP : CHARM_SCALE; }

  /* ---- Bases (SVG d'aperçu — placeholders tant qu'il n'y a pas de photo) --- */
  var _bandanaSeq = 0;   // id de motif UNIQUE par instance (sinon plusieurs SVG partagent le même #czband → triangles non remplis)
  function bandanaSvg() {
    var pid = 'czband' + (++_bandanaSeq);
    return '<svg viewBox="0 0 400 400" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Bandana">'
      + '<defs><pattern id="' + pid + '" width="34" height="34" patternUnits="userSpaceOnUse" patternTransform="rotate(45)">'
      + '<rect width="34" height="34" fill="#ff8fae"/>'
      + '<circle cx="9" cy="9" r="3.2" fill="#fffefa" opacity=".9"/><circle cx="26" cy="26" r="3.2" fill="#fffefa" opacity=".9"/>'
      + '<path d="M22 5 q6 4 0 9 q-6 -4 0 -9Z" fill="#ffd23f" opacity=".95"/></pattern></defs>'
      + '<path d="M64 132 H336 L200 322 Z" fill="url(#' + pid + ')" stroke="#e60837" stroke-width="5" stroke-linejoin="round"/>'
      + '<path d="M64 132 H336" stroke="#e60837" stroke-width="9" stroke-linecap="round"/></svg>';
  }
  function neckSvg(main, hi, w, dash, clasp) {
    var d = 'M96 120 Q200 420 304 120';
    return '<svg viewBox="0 0 400 400" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Collier">'
      + '<path d="' + d + '" fill="none" stroke="' + main + '" stroke-width="' + w + '" stroke-linecap="round"/>'
      + '<path d="' + d + '" fill="none" stroke="' + hi + '" stroke-width="' + dash.w + '" stroke-dasharray="' + dash.p + '" stroke-linecap="round" opacity=".85"/>'
      + '<circle cx="96" cy="120" r="' + clasp + '" fill="' + main + '"/><circle cx="304" cy="120" r="' + clasp + '" fill="' + main + '"/></svg>';
  }
  function bracSvg(main, hi, w, dash, clasp) {
    var d = 'M104 196 Q200 268 296 196';
    return '<svg viewBox="0 0 400 400" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Bracelet">'
      + '<path d="' + d + '" fill="none" stroke="' + main + '" stroke-width="' + w + '" stroke-linecap="round"/>'
      + '<path d="' + d + '" fill="none" stroke="' + hi + '" stroke-width="' + dash.w + '" stroke-dasharray="' + dash.p + '" stroke-linecap="round" opacity=".85"/>'
      + '<circle cx="104" cy="196" r="' + clasp + '" fill="' + main + '"/><circle cx="296" cy="196" r="' + clasp + '" fill="' + main + '"/></svg>';
  }
  var SHAPES = {
    'bandana':    bandanaSvg,
    'chain-neck': function () { return neckSvg('#cf9a34', '#f3dd9a', 8, { w: 3, p: '2 7' }, 8); },
    'rope-neck':  function () { return neckSvg('#c69b63', '#e4c79a', 11, { w: 11, p: '3 10' }, 9); },
    'chain-brac': function () { return bracSvg('#cf9a34', '#f3dd9a', 7, { w: 3, p: '2 7' }, 7); },
    'rope-brac':  function () { return bracSvg('#c69b63', '#e4c79a', 10, { w: 10, p: '3 10' }, 8); }
  };

  /* ---- Emplacements par forme (en % de la scène) ---- */
  var SLOTLAYOUTS = {
    'bandana-cou':    [{ x: 24.8, y: 67.6 }, { x: 38.2, y: 79.5 }, { x: 51.3, y: 91.1 }, { x: 63.9, y: 79.1 }, { x: 77, y: 67.1 }],
    'bandana-tete':   [{ x: 22.4, y: 70.1 }, { x: 31.9, y: 69.8 }, { x: 40.9, y: 69.3 }, { x: 50.3, y: 69.3 }, { x: 59.2, y: 69.3 }, { x: 68.2, y: 69.6 }, { x: 77.7, y: 69.6 }],
    'collier-chaine': [{ x: 11, y: 51 }, { x: 20, y: 61 }, { x: 32, y: 68 }, { x: 50, y: 72 }, { x: 65, y: 68 }, { x: 76, y: 59 }, { x: 83, y: 50 }],
    'bracelet-chaine':[{ x: 26, y: 48 }, { x: 38, y: 55 }, { x: 50, y: 58 }, { x: 62, y: 55 }, { x: 74, y: 48 }],
    'collier-corde':  [{ x: 11, y: 51 }, { x: 20, y: 61 }, { x: 32, y: 68 }, { x: 50, y: 72 }, { x: 65, y: 68 }, { x: 76, y: 59 }, { x: 83, y: 50 }],
    'bracelet-corde': [{ x: 26, y: 48 }, { x: 38, y: 55 }, { x: 50, y: 58 }, { x: 62, y: 55 }, { x: 74, y: 48 }]
  };

  /* ---- Produits (base = prix affiché par défaut ; le vrai prix + les couleurs
     sont lus sur Shopify quand le produit existe). Charms INCLUS. ---- */
  var PRODUCTS = [
    { key: 'bandana-cou',     short: 'bandana',  name: 'Bandana à charms — cou',      shape: 'bandana',    base: 30, handle: 'bandana-charms-cou' },
    { key: 'bandana-tete',    short: 'bandana',  name: 'Bandana à charms — tête',     shape: 'bandana',    base: 40, handle: 'bandana-charms-tete' },
    { key: 'collier-chaine',  short: 'collier',  name: 'Collier chaîne à charms',     shape: 'chain-neck', base: 25, handle: 'collier-chaine-charms', cm: 27, frac: 1.15, smallSlots: true, variantLabel: 'Chaîne', formulas: [{ n: 3, price: 25 }, { n: 5, price: 30 }, { n: 7, price: 35 }] },
    { key: 'bracelet-chaine', short: 'bracelet', name: 'Bracelet chaîne à charms',    shape: 'chain-brac', base: 25, handle: 'bracelet-chaine-charms', cm: 29, frac: 1.50, smallSlots: true, variantLabel: 'Chaîne', formulas: [{ n: 3, price: 25 }, { n: 5, price: 30 }] },
    { key: 'collier-corde',   short: 'collier',  name: 'Collier corde à charms',      shape: 'rope-neck',  base: 25, handle: 'collier-corde-charms', cm: 27, frac: 1.15, smallSlots: true, variantLabel: 'Corde', formulas: [{ n: 3, price: 25 }, { n: 5, price: 30 }, { n: 7, price: 35 }] },
    { key: 'bracelet-corde',  short: 'bracelet', name: 'Bracelet corde à charms',     shape: 'rope-brac',  base: 25, handle: 'bracelet-corde-charms', cm: 29, frac: 1.60, smallSlots: true, variantLabel: 'Corde', formulas: [{ n: 3, price: 25 }, { n: 5, price: 30 }] }
  ];
  PRODUCTS.forEach(function (p) { p.slots = SLOTLAYOUTS[p.key] || []; });

  /* ---- Modèles d'inspiration : couleur + charms déjà posés (bandana cou) ----
     La cliente peut en ajouter/modifier : name + color (doit EXACTEMENT matcher un
     nom de #czColorAssets) + charms[] (un id de CHARMS par emplacement, 0..4). ---- */
  var LOOKS = [
    // Bandana COU — vraies photos (5 charms). Les charms = slugs du catalogue #czCharmAssets.
    { product: 'bandana-cou', name: 'Bord de mer',    color: 'Bleu ciel',   charms: ['charm-112', 'charm-80', 'charm-30', 'charm-46', 'charm-83'] },
    { product: 'bandana-cou', name: 'Tout cœur',      color: 'Rouge',       charms: ['charm-96', 'charm-94', 'charm-95', 'charm-96', 'charm-94'] },
    { product: 'bandana-cou', name: 'Gourmande',      color: 'Rose bébé',   charms: ['charm-93', 'charm-109', 'charm-57', 'charm-109', 'charm-93'] },
    { product: 'bandana-cou', name: 'Tropical',       color: 'Orange',      charms: ['charm-64', 'charm-84', 'charm-57', 'charm-84', 'charm-64'] },
    { product: 'bandana-cou', name: 'Animaux marins', color: 'Bleu marine', charms: ['charm-100', 'charm-102', 'charm-38', 'charm-106', 'charm-105'] },
    // Bandana TÊTE — vraies photos (5 charms), même système que le cou
    { product: 'bandana-tete', name: 'Coquillages',  color: 'Bleu ciel',   charms: ['charm-112', 'charm-47', 'charm-46', 'charm-49', 'charm-46', 'charm-47', 'charm-112'] },
    { product: 'bandana-tete', name: 'Cœurs',        color: 'Rouge',       charms: ['charm-96', 'charm-94', 'charm-95', 'charm-97', 'charm-95', 'charm-94', 'charm-96'] },
    { product: 'bandana-tete', name: 'Été fruité',   color: 'Rose bébé',   charms: ['charm-93', 'charm-109', 'charm-57', 'charm-64', 'charm-57', 'charm-109', 'charm-93'] },
    // Colliers CORDE — vraies photos (7 charms), une idée par ambiance
    { product: 'collier-corde',  name: 'Bord de mer', color: 'Lagon',  charms: ['charm-83', 'charm-80', 'charm-112', 'charm-30', 'charm-112', 'charm-80', 'charm-83'] },
    { product: 'collier-corde',  name: 'Tout cœur',   color: 'Corail', charms: ['charm-96', 'charm-94', 'charm-95', 'charm-97', 'charm-95', 'charm-94', 'charm-96'] },
    { product: 'collier-corde',  name: 'Gourmande',   color: 'Dragée', charms: ['charm-93', 'charm-109', 'charm-57', 'charm-64', 'charm-57', 'charm-109', 'charm-93'] },
    // Colliers CHAÎNE — vraies photos (7 charms)
    { product: 'collier-chaine', name: 'Nacrée',         color: 'Riviera', charms: ['charm-31', 'charm-47', 'charm-96', 'charm-31', 'charm-96', 'charm-47', 'charm-31'] },
    { product: 'collier-chaine', name: 'Animaux marins', color: 'Précieuse',  charms: ['charm-105', 'charm-100', 'charm-102', 'charm-38', 'charm-102', 'charm-100', 'charm-105'] },
    { product: 'collier-chaine', name: 'Rose tendre',    color: 'Éclat',   charms: ['charm-96', 'charm-93', 'charm-109', 'charm-57', 'charm-109', 'charm-93', 'charm-96'] },
    // Bracelets CORDE — vraies photos (5 charms)
    { product: 'bracelet-corde', name: 'Vague',      color: 'Nomade',    charms: ['charm-80', 'charm-112', 'charm-30', 'charm-112', 'charm-80'] },
    { product: 'bracelet-corde', name: 'Cœur tendre', color: 'Aurore',   charms: ['charm-96', 'charm-94', 'charm-95', 'charm-94', 'charm-96'] },
    { product: 'bracelet-corde', name: 'Soleil',     color: 'Solaire',   charms: ['charm-64', 'charm-84', 'charm-57', 'charm-84', 'charm-64'] },
    // Bracelets CHAÎNE — vraies photos (5 charms)
    { product: 'bracelet-chaine', name: 'Nacre',    color: 'Charmante',  charms: ['charm-31', 'charm-47', 'charm-96', 'charm-47', 'charm-31'] },
    { product: 'bracelet-chaine', name: 'Passion',  color: 'Rebelle',    charms: ['charm-96', 'charm-94', 'charm-95', 'charm-94', 'charm-96'] },
    { product: 'bracelet-chaine', name: 'Animaux marins', color: 'Iconic', charms: ['charm-102', 'charm-105', 'charm-38', 'charm-105', 'charm-102'] }
  ];

  var current = null;         // produit actif
  var state = { slots: {} };  // { indexEmplacement: idCharm }
  var activeCharm = null;
  var lastPlaced = -1;        // pour l'animation de rebond
  var variants = [];          // couleurs chargées depuis Shopify
  var colorIdx = 0;           // couleur affichée
  var colorChosen = false;    // la couleur a-t-elle été validée ?
  var hasColors = false;      // le produit propose-t-il un choix de couleur ?
  var loading = false;        // produit en cours de chargement (verrouille les charms)
  var cartVid = null;         // variante Shopify pour l'ajout panier (produit à variante unique)
  var formulaIdx = 0;         // formule choisie (ex. bracelet : 0 = 3 charms/25€, 1 = 5 charms/30€)
  var shopVariants = [];      // variantes Shopify brutes (pour choisir la bonne selon la formule = le bon prix)
  var activeSlots = [];       // positions des emplacements de la couleur active (les œillets de CETTE couleur)
  var DANGLE = 5;             // % : le charm posé pend un peu SOUS l'œillet (comme suspendu par l'anneau)
  var PHOTO_AR = { 'bandana-cou': '820 / 761', 'bandana-tete': '820 / 955', 'collier-corde': '1500 / 1900', 'collier-chaine': '1500 / 1900', 'bracelet-corde': '2000 / 1500', 'bracelet-chaine': '2000 / 1200' };   // aspect réel de chaque photo (mini-aperçus des idées) — sinon fond rogné → charms décalés des œillets

  /* Couleurs fournies par le thème (photos en assets) — voir #czColorAssets dans la page */
  var COLORASSETS = {};
  (function () { var s = document.getElementById('czColorAssets'); if (s) { try { COLORASSETS = JSON.parse(s.textContent) || {}; } catch (e) { COLORASSETS = {}; } } })();

  /* ---- Utilitaires ---- */
  function money(n) { return (n).toFixed(2).replace('.', ',') + ' €'; }
  function esc(s) { return ('' + s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function charmSvg(id, opt) {
    var c = CHARMS[id]; if (!c) return '';
    var st = '';
    if (opt && opt.px != null) st = 'width:' + opt.px + 'px;height:' + (c.w ? (opt.px * c.h / c.w).toFixed(1) : opt.px) + 'px';   // taille réelle + HAUTEUR EXPLICITE (ratio catalogue) → pas de hauteur 0 avant décodage (capture panier fiable)
    else if (opt && opt.cap != null) st = 'max-width:' + opt.cap + ';max-height:' + opt.cap; // plafond (palette / mini)
    // charms POSÉS (opt.px) = toujours visibles → chargement immédiat (eager) pour ne pas clignoter/être éjectés ; palette/mini = lazy (112 vignettes)
    var lazy = (opt && opt.px != null) ? '' : ' loading="lazy"';
    return '<img class="charm-img" src="' + c.img + '" alt="' + esc(c.name) + '" style="' + st + '" draggable="false"' + lazy + '>';
  }
  function toast(msg) {
    var t = document.createElement('div'); t.className = 'cz-toast'; t.textContent = msg;
    document.body.appendChild(t);
    requestAnimationFrame(function () { t.classList.add('show'); });
    setTimeout(function () { t.classList.remove('show'); setTimeout(function () { t.remove(); }, 300); }, 2200);
  }
  function bySlug(s) { for (var i = 0; i < PRODUCTS.length; i++) { if (PRODUCTS[i].key === s) return PRODUCTS[i]; } return null; }
  function clearCharmSelection() {
    activeCharm = null;
    if (charmsWrap) charmsWrap.querySelectorAll('.charm-chip').forEach(function (c) { c.classList.remove('is-sel'); });
  }

  /* ---- Galerie de vignettes ---- */
  if (picker) picker.innerHTML = '';                 // enlève les squelettes de chargement (HTML statique) avant de poser les vraies vignettes
  PRODUCTS.forEach(function (p) {
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'cz-pick'; b.setAttribute('role', 'listitem');
    var pickImg = (window.CZ_PICK && window.CZ_PICK[p.key]) || null;   // vraie photo de vignette si fournie (window.CZ_PICK), sinon dessin SVG
    var pickArt = pickImg ? '<img class="cz-pick__photo" src="' + pickImg + '" alt="' + esc(p.name) + '" loading="lazy">' : SHAPES[p.shape]();
    b.innerHTML = '<span class="cz-pick__art">' + pickArt + '</span>'
      + '<span class="cz-pick__name">' + p.name + '</span>'
      + '<span class="cz-pick__meta">' + (p.formulas ? (p.formulas[0].n + ' à ' + p.formulas[p.formulas.length - 1].n) : p.slots.length) + ' charms à composer</span>';
    b.addEventListener('click', function () { openProduct(p); });
    picker.appendChild(b);
  });

  /* Vignette « Pas d'idée ? » RETIRÉE du sélecteur (demande cliente).
     La galerie d'idées (showIdeas / #idees) reste définie pour ne rien casser,
     mais elle n'est plus proposée comme catégorie dans la personnalisation. */

  /* Le stage épouse l'aspect de la photo chargée (fillage exact → les œillets/slots
     tombent juste quelle que soit la forme : cou plus large, tête plus haute…). */
  function fitStage() {
    var ims = art.querySelectorAll('img.cz__photo');
    var im = ims[ims.length - 1];                    // la plus récente (2 photos coexistent le temps du fondu)
    if (!im) { stage.style.aspectRatio = ''; return; }
    var apply = function () { if (im.naturalWidth && im.naturalHeight) stage.style.aspectRatio = im.naturalWidth + ' / ' + im.naturalHeight; };
    im.addEventListener('load', apply); apply();   // écouteur + tentative immédiate (image en cache déjà décodée)
  }
  /* Change la photo de l'aperçu en FONDU ENCHAÎNÉ (transition douce entre chaînes / couleurs) */
  function setPhoto(src, alt) {
    stage.classList.add('has-photo');
    var olds = art.querySelectorAll('img.cz__photo');
    var img = document.createElement('img');
    img.className = 'cz__photo'; img.alt = alt || ''; img.style.opacity = '0';
    var reveal = function () {
      var svg = art.querySelector('svg'); if (svg && svg.parentNode) svg.parentNode.removeChild(svg);   // retire le tracé de secours (sinon il transparaît sous la photo transparente)
      void img.offsetWidth;                          // reflow forcé → l'opacité 0 de départ est prise en compte, la transition joue
      img.style.opacity = '1';                       // fondu 0 → 1
      Array.prototype.forEach.call(olds, function (o) { o.style.opacity = '0'; setTimeout(function () { if (o.parentNode) o.parentNode.removeChild(o); }, 360); });   // ancienne(s) photo(s) : fondu sortant puis retrait
      fitStage();
    };
    img.addEventListener('load', reveal); img.addEventListener('error', reveal);
    art.appendChild(img);
    img.src = src;
    if (img.complete && img.naturalWidth) reveal();  // image déjà en cache
  }

  /* ---- Ouvrir / fermer un produit ---- */
  function openProduct(p, fromHistory) {
    current = p; state = { slots: {} }; activeCharm = null; lastPlaced = -1;
    variants = []; colorIdx = 0; colorChosen = false; hasColors = false; loading = true; cartVid = null; shopVariants = [];
    activeSlots = (p.slots || []).slice();     // par défaut : les emplacements génériques du produit
    document.getElementById('czProdName').textContent = p.name;
    document.getElementById('czHeadLead').textContent = 'Choisis tes charms et pose-les sur ton ' + p.short + ' 🐚';
    var clbl = document.getElementById('czColorLabel');
    if (clbl) clbl.textContent = p.variantLabel ? ((p.variantLabel === 'Corde' ? '🪢' : '🔗') + ' Choisis ta ' + p.variantLabel.toLowerCase() + ' — fais défiler') : '🎨 Couleur du ' + p.short + ' — fais défiler pour changer';
    stage.classList.remove('has-photo'); stage.style.aspectRatio = '';
    art.innerHTML = SHAPES[p.shape]();
    stage.setAttribute('data-shape', p.shape);
    formulaIdx = 0;
    priceEl.textContent = money(p.formulas ? p.formulas[0].price : p.base);
    buildFormula();
    if (colorNameEl) colorNameEl.textContent = '—';
    clearCharmSelection();
    var ca = COLORASSETS[p.key];
    if (ca && ca.length) {                    // couleurs fournies par le thème (photos) → carrousel direct, sans attendre
      hasColors = true; colorChosen = false; loading = false; colorIdx = 0;
      variants = ca.map(function (c) { return { color: c.name, img: c.img, id: null, price: null, available: true, slots: (c.slots || []).map(function (q) { return { x: q[0], y: q[1] }; }) }; });
      buildColorStrip(); showColor(0);
    }
    applyColorGate();
    gallery.hidden = true; builder.hidden = false; if (ideasEl) ideasEl.hidden = true;
    if (!fromHistory && history.pushState) { try { history.pushState({ czView: 'product', key: p.key }, '', '#' + p.key); } catch (e) {} }
    loadProduct(p);
    update();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
  function showGallery() { builder.hidden = true; if (ideasEl) ideasEl.hidden = true; gallery.hidden = false; current = null; }
  function goBack() {   // « ← » et bouton précédent du navigateur → reviennent à la galerie perso
    if (history.state && history.state.czView) history.back();   // dépile la vue (produit/idées) → popstate → route
    else { showGallery(); if (history.replaceState) { try { history.replaceState({}, '', location.pathname + location.search); } catch (e) {} } }
  }
  function route(fromHistory) {   // affiche la bonne vue selon l'URL (chargement + popstate)
    var h = (location.hash || '').replace('#', '');
    if (h === 'idees') showIdeas(fromHistory);
    else { var p = bySlug(h); if (p) openProduct(p, fromHistory); else showGallery(); }
  }
  window.addEventListener('popstate', function () { route(true); });
  var backBtn = document.getElementById('czBack');
  if (backBtn) backBtn.addEventListener('click', goBack);

  /* ---- Chargement produit Shopify : prix + couleurs (variantes avec photo) -- */
  function loadProduct(p) {
    fetch('/products/' + p.handle + '.js').then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(function (prod) {
        if (current !== p) return;
        if (prod.price != null) priceEl.textContent = money(prod.price / 100);
        var vs = prod.variants || [];
        shopVariants = vs;                                             // gardées pour choisir la variante selon la formule
        var av = vs.filter(function (v) { return v.available; });
        cartVid = ((av[0] || vs[0] || {}).id) || null;                 // variante pour l'ajout panier
        if (COLORASSETS[p.key] && COLORASSETS[p.key].length) {         // couleurs déjà affichées (photos du thème) : on ne touche qu'au prix + cartVid
          loading = false; applyColorGate(); update(); return;
        }
        var pf = (prod.featured_image) || (prod.images && prod.images[0]) || null;
        var list = vs.map(function (v) {
          return {
            id: v.id,
            color: (v.option1 && v.option1 !== 'Default Title') ? v.option1 : '',   // nom de couleur (pas le title)
            img: (v.featured_image && v.featured_image.src) ? v.featured_image.src : null,
            price: v.price, available: v.available
          };
        });
        var imgs = list.filter(function (x) { return x.img; });                    // AVANT toute retouche
        var colored = list.filter(function (x) { return x.color; });               // tous les vrais coloris
        var carousel = false;
        if (colored.length >= 2) {
          colored.forEach(function (x) { if (!x.img) x.img = pf; });                // vignette de secours
          if (colored.filter(function (x) { return x.img; }).length >= 1) carousel = true;
        }
        if (carousel) {                              // plusieurs couleurs → carrousel, on choisit AVANT les charms
          hasColors = true; variants = colored; colorChosen = false; colorIdx = 0;
          buildColorStrip(); showColor(0);
        } else if (imgs.length >= 1) {               // une seule photo → base fixe (la variante de CETTE photo)
          hasColors = false; colorChosen = true; variants = [imgs[0]]; colorIdx = 0;
          stage.classList.add('has-photo');
          setPhoto(imgs[0].img, p.name);
          if (imgs[0].price != null) priceEl.textContent = money(imgs[0].price / 100);
        } else {                                     // pas de photo → dessin provisoire ; variante dispo par défaut
          hasColors = false; colorChosen = true; colorIdx = 0;
          var avail = list.filter(function (x) { return x.available; });
          variants = avail.length ? avail : list;
        }
        loading = false; applyColorGate(); update();
      })
      .catch(function () {   // produit pas encore créé
        if (current !== p) return;
        loading = false;
        if (!(COLORASSETS[p.key] && COLORASSETS[p.key].length)) { hasColors = false; variants = []; colorChosen = true; }
        applyColorGate(); update();
      });
  }

  /* ---- Carrousel de couleurs ---- */
  function buildColorStrip() {
    if (!colorsWrap) return;
    colorsWrap.innerHTML = '';
    variants.forEach(function (v, i) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'cz__color';
      if (v.img) b.style.backgroundImage = "url('" + v.img + "')";
      b.title = v.color; b.setAttribute('aria-label', 'Couleur ' + v.color);
      b.addEventListener('click', function () { showColor(i); });
      colorsWrap.appendChild(b);
    });
  }
  function showColor(i) {
    if (!variants.length) return;
    colorIdx = Math.max(0, Math.min(variants.length - 1, i));
    var v = variants[colorIdx];
    if (v.img) { setPhoto(v.img, current.name + ' ' + v.color); }
    if (v.slots && v.slots.length) { activeSlots = v.slots; if (!repositionStage()) renderStage(); }   // œillets propres à cette couleur → repositionne les charms existants (sans re-décodage = pas de clignotement mobile), sinon rendu complet
    if (v.price != null) priceEl.textContent = money(v.price / 100);
    if (colorNameEl) colorNameEl.textContent = v.color || '—';
    if (colorsWrap) {
      var t = colorsWrap.querySelectorAll('.cz__color');
      for (var j = 0; j < t.length; j++) { var on = (j === colorIdx); t[j].classList.toggle('is-active', on); t[j].setAttribute('aria-pressed', on ? 'true' : 'false'); }
      var act = t[colorIdx];   // la barre de couleurs défile pour suivre la couleur affichée (sync avec le swipe)
      if (act) {
        var ar = act.getBoundingClientRect(), sr = colorsWrap.getBoundingClientRect();
        var delta = (ar.left - sr.left) - (colorsWrap.clientWidth - ar.width) / 2;
        if (Math.abs(delta) > 2) colorsWrap.scrollLeft += delta;
      }
    }
  }
  function chooseColor() {
    colorChosen = true; applyColorGate(); update();
    // Après « Personnaliser avec mes charms » : on montre la FORMULE (on ne descend PAS jusqu'aux charms)
    var fEl = document.getElementById('czFormula');
    var target = (fEl && !fEl.hidden) ? fEl : charmStepEl;
    if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
  function applyColorGate() {
    var pick = hasColors && !colorChosen;
    if (colorStepEl) colorStepEl.hidden = !hasColors;      // la barre de couleurs reste après le choix (pour changer)
    if (prevBtn) prevBtn.hidden = !pick;                    // flèches/swipe seulement pendant le choix de couleur
    if (nextBtn) nextBtn.hidden = !pick;
    if (goBtn) goBtn.hidden = !pick;
    if (charmStepEl) charmStepEl.classList.toggle('is-locked', loading || pick);
    root.classList.toggle('cz--pick', pick);
    var fEl = document.getElementById('czFormula');
    if (fEl) fEl.hidden = !(current && current.formulas) || pick;   // formule visible une fois la chaîne choisie
  }
  /* ---- Formule (nb de charms + prix), ex. bracelet : 3 charms 25€ / 5 charms 30€ ---- */
  function maxCharms() { return (current && current.formulas) ? current.formulas[formulaIdx].n : (activeSlots.length || (current && current.slots ? current.slots.length : 0)); }
  function buildFormula() {
    var box = document.getElementById('czFormula'); if (!box) return;
    if (!(current && current.formulas)) { box.innerHTML = ''; return; }
    box.innerHTML = '<h3>💫 Choisis ta formule</h3><div class="cz__formopts" role="group" aria-label="Formule"></div>';
    var opts = box.querySelector('.cz__formopts');
    current.formulas.forEach(function (f, i) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'cz-form' + (i === formulaIdx ? ' is-active' : '');
      b.setAttribute('aria-pressed', i === formulaIdx ? 'true' : 'false');
      b.innerHTML = '<b>' + f.n + ' charms</b><span>' + money(f.price) + '</span>';
      b.addEventListener('click', function () { setFormula(i); });
      opts.appendChild(b);
    });
  }
  function setFormula(i) {
    if (!(current && current.formulas)) return;
    formulaIdx = Math.max(0, Math.min(current.formulas.length - 1, i));
    var f = current.formulas[formulaIdx];
    priceEl.textContent = money(f.price);
    var keys = Object.keys(state.slots).map(Number).sort(function (a, b) { return a - b; });
    if (keys.length > f.n) { keys.slice(f.n).forEach(function (k) { delete state.slots[k]; }); toast('Formule ' + f.n + ' charms : on garde tes ' + f.n + ' premiers 💫'); }
    buildFormula(); update();
  }
  if (prevBtn) prevBtn.addEventListener('click', function () { showColor(colorIdx - 1); });
  if (nextBtn) nextBtn.addEventListener('click', function () { showColor(colorIdx + 1); });
  if (goBtn) goBtn.addEventListener('click', chooseColor);
  // Swipe pour faire défiler les couleurs — UNIQUEMENT pendant le choix (sinon conflit avec la pose de charms)
  var tsx = null;
  stage.addEventListener('touchstart', function (e) { if (hasColors && !colorChosen && e.touches[0]) tsx = e.touches[0].clientX; }, { passive: true });
  stage.addEventListener('touchend', function (e) {
    if (!(hasColors && !colorChosen) || tsx == null) { tsx = null; return; }
    var dx = e.changedTouches[0].clientX - tsx;
    if (Math.abs(dx) > 40) showColor(colorIdx + (dx < 0 ? 1 : -1));
    tsx = null;
  }, { passive: true });

  /* ---- « Pas d'idée ? » : galerie d'idées + choix reproduire / personnaliser ---- */
  var ideasEl = document.getElementById('czIdeas');
  var modalEl = document.getElementById('czIdeaModal');
  var PLABEL = { 'bandana-cou': 'Bandana cou', 'bandana-tete': 'Bandana tête', 'collier-chaine': 'Collier chaîne', 'bracelet-chaine': 'Bracelet chaîne', 'collier-corde': 'Collier corde', 'bracelet-corde': 'Bracelet corde' };
  function prodLabel(key) { return PLABEL[key] || key; }

  // Mini-aperçu d'un modèle : photo (bandana cou) OU dessin SVG (autres bases) + charms posés
  function miniLook(look) {
    var p = bySlug(look.product) || PRODUCTS[0];
    var ca = COLORASSETS[look.product];
    var slots = [], bg = '', shape = '', arStyle = '';
    if (ca && ca.length && look.color) {
      var c = null;
      for (var i = 0; i < ca.length; i++) { if (ca[i].name === look.color) { c = ca[i]; break; } }
      if (!c) c = ca[0];
      slots = (c.slots || []).map(function (q) { return { x: q[0], y: q[1] }; });
      bg = "background-image:url('" + c.img + "')";
      arStyle = 'aspect-ratio:' + (PHOTO_AR[look.product] || '820 / 761') + ';';   // la mini-vignette prend l'aspect de LA photo → plus de rognage, œillets alignés
    } else {
      slots = SLOTLAYOUTS[look.product] || [];
      shape = SHAPES[p.shape] ? SHAPES[p.shape]() : '';
    }
    var charms = (look.charms || []).map(function (cid, idx) {
      if (!cid || !CHARMS[cid] || !slots[idx]) return '';
      return '<span class="cz-insp__charm" style="left:' + slots[idx].x + '%;top:' + (slots[idx].y + DANGLE) + '%">' + charmSvg(cid, { cap: '100%' }) + '</span>';
    }).join('');
    return '<span class="cz-insp__stage' + (shape ? ' cz-insp__stage--svg' : '') + '" style="' + arStyle + bg + '">'
      + (shape ? '<span class="cz-insp__svg">' + shape + '</span>' : '') + charms + '</span>';
  }

  // Applique un modèle DANS le configurateur (produit déjà ouvert) : couleur + charms posés
  function applyLook(look) {
    if (!current) return;
    var ci = 0;
    for (var i = 0; i < variants.length; i++) { if (variants[i].color === look.color) { ci = i; break; } }
    colorChosen = true; loading = false; applyColorGate();   // saute le choix couleur + débloque les charms
    state.slots = {};
    (look.charms || []).forEach(function (cid, idx) { if (cid && CHARMS[cid]) state.slots[idx] = cid; });
    if (current.formulas) {                                  // idée à N charms → cale la formule (et donc le prix) sur N
      var needN = Object.keys(state.slots).length, fIdx = current.formulas.length - 1;
      for (var fk = 0; fk < current.formulas.length; fk++) { if (current.formulas[fk].n >= needN) { fIdx = fk; break; } }
      formulaIdx = fIdx; if (priceEl) priceEl.textContent = money(current.formulas[fIdx].price); buildFormula();
    }
    if (variants.length) showColor(ci);                      // couleur + œillets de CETTE couleur
    lastPlaced = -1; clearCharmSelection(); update();
    toast('Modèle « ' + look.name + ' » — à toi de l’ajuster ✨');
    if (stage.scrollIntoView) stage.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  // Grille d'idées (tous produits confondus)
  function buildIdeas() {
    var grid = document.getElementById('czIdeasGrid');
    if (!grid) return;
    grid.innerHTML = '';
    LOOKS.forEach(function (look) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'cz-idea'; b.setAttribute('role', 'listitem');
      b.setAttribute('aria-label', look.name + ' — ' + prodLabel(look.product));
      b.innerHTML = miniLook(look) + '<span class="cz-idea__name">' + look.name + '</span><span class="cz-idea__prod">' + prodLabel(look.product) + '</span>';
      b.addEventListener('click', function () { openIdeaModal(look); });
      grid.appendChild(b);
    });
  }
  function showIdeas(fromHistory) {
    buildIdeas();
    gallery.hidden = true; builder.hidden = true; if (ideasEl) ideasEl.hidden = false;
    if (!fromHistory && history.pushState) { try { history.pushState({ czView: 'ideas' }, '', '#idees'); } catch (e) {} }
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
  var ideasBack = document.getElementById('czIdeasBack');
  if (ideasBack) ideasBack.addEventListener('click', goBack);

  // Fenêtre de choix : reproduire à l'identique OU personnaliser
  var pendingLook = null;
  function openIdeaModal(look) {
    pendingLook = look;
    var pv = document.getElementById('czModalPreview'); if (pv) pv.innerHTML = miniLook(look);
    var nm = document.getElementById('czModalName'); if (nm) nm.textContent = look.name;
    var pr = document.getElementById('czModalProd'); if (pr) pr.textContent = prodLabel(look.product);
    if (modalEl) modalEl.hidden = false;
    document.body.classList.add('cz-modal-open');
  }
  function closeIdeaModal() { if (modalEl) modalEl.hidden = true; pendingLook = null; document.body.classList.remove('cz-modal-open'); }
  var mRepro = document.getElementById('czModalRepro');
  var mPerso = document.getElementById('czModalPerso');
  var mClose = document.getElementById('czModalClose');
  if (mRepro) mRepro.addEventListener('click', function () {
    var look = pendingLook; closeIdeaModal(); if (!look) return;
    var p = bySlug(look.product); if (!p) return;
    openProduct(p); applyLook(look);                          // reproduit exactement le modèle
  });
  if (mPerso) mPerso.addEventListener('click', function () {
    var look = pendingLook; closeIdeaModal(); if (!look) return;
    var p = bySlug(look.product); if (!p) return;
    openProduct(p);                                           // configurateur vierge de ce produit
  });
  if (mClose) mClose.addEventListener('click', closeIdeaModal);
  if (modalEl) modalEl.querySelectorAll('[data-close]').forEach(function (el) { el.addEventListener('click', closeIdeaModal); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && modalEl && !modalEl.hidden) closeIdeaModal(); });

  /* ---- Conversion cm réels → px sur l'aperçu (charms + anneau, même échelle) ---- */
  var RING_CM = 0.55;         // anneau de jonction plus petit (plus réaliste vs les charms)
  var RING_IMG = window.CZ_RING || '';   // vraie photo d'anneau (détourée), injectée dans la page
  var LOOPX = window.CZ_LOOPX || {};     // position horizontale de la BOUCLE de chaque charm (0-1) pour l'aligner sur l'œillet
  function cmToPx(cm) { var pcm = (current && current.cm) || BANDANA_CM, pf = (current && current.frac) || BANDANA_FRAC; return (cm / pcm) * pf * stage.clientWidth * charmScale(); }
  function charmPx(id) { var c = CHARMS[id]; return cmToPx((c && c.w_cm) ? c.w_cm : 2); }
  function charmHpx(id) { var c = CHARMS[id]; return cmToPx((c && c.h_cm) ? c.h_cm : 2); }
  window.addEventListener('resize', function () { if (current) renderStage(); });

  /* ---- Glisser un charm posé : l'échanger avec un autre, ou le jeter (corbeille) ----
     Pointer Events → marche à la souris (desktop) ET au doigt (mobile). ---- */
  var drag = null;
  var paletteDidDrag = false;   // un glissé depuis la palette vient de placer un charm → on ignore le clic qui suit
  var _dragRaf = 0, _dragX = 0, _dragY = 0;   // survol (corbeille/emplacements) throttlé 1×/frame → fluidité mobile
  function ensureTrash() {
    var t = document.getElementById('czTrash');
    if (!t) {
      t = document.createElement('div');
      t.id = 'czTrash'; t.className = 'cz-trash';
      t.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13"/><path d="M10 11v6M14 11v6"/></svg><span>Jeter</span>';
      stage.parentNode.appendChild(t);   // dans l'angle bas-droit de la vignette bandana (.cz__stagewrap)
    }
    return t;
  }
  function targetAt(x, y) { return document.elementFromPoint(x, y); }   // le fantôme est pointer-events:none → déjà ignoré (plus de masquage/reflow)
  function clearDropHints() {
    var d = slotsWrap.querySelectorAll('.is-drop'); for (var i = 0; i < d.length; i++) d[i].classList.remove('is-drop');
    var t = document.getElementById('czTrash'); if (t) t.classList.remove('is-over');
  }
  function dragSrcId() { return drag.palette != null ? drag.palette : state.slots[drag.from]; }
  function bindDrag() {   // écoute au niveau DOCUMENT → le glissé suit le pointeur partout et se termine toujours (plus de figeage)
    document.addEventListener('pointermove', onDragMove);
    document.addEventListener('pointerup', endDrag);
    document.addEventListener('pointercancel', endDrag);
  }
  function unbindDrag() {
    document.removeEventListener('pointermove', onDragMove);
    document.removeEventListener('pointerup', endDrag);
    document.removeEventListener('pointercancel', endDrag);
  }
  function startCharmDrag(e, idx, el) {     // charm POSÉ (souris + tactile) → échanger / jeter
    if (e.pointerType === 'mouse' && e.button !== 0) return;
    if (state.slots[idx] == null) return;
    if (drag) endDrag(null);                // anti-blocage : nettoie un éventuel glissé resté ouvert
    paletteDidDrag = false;
    drag = { from: idx, palette: null, x0: e.clientX, y0: e.clientY, active: false, el: el };
    bindDrag();
  }
  function startPaletteDrag(e, charmId, el) {   // PALETTE (souris/desktop) → poser sur un emplacement
    if (e.pointerType !== 'mouse' || e.button !== 0) return;
    if (drag) endDrag(null);
    paletteDidDrag = false;
    drag = { from: null, palette: charmId, x0: e.clientX, y0: e.clientY, active: false, el: el };
    bindDrag();
  }
  function beginDrag() {
    drag.active = true;
    var srcId = dragSrcId();
    var g = document.createElement('div'); g.className = 'cz-drag-ghost';
    g.innerHTML = charmSvg(srcId, { px: charmPx(srcId) * 1.15 });
    g.style.left = '0'; g.style.top = '0'; g.style.willChange = 'transform';   // positionné en transform (GPU) → suivi fluide
    document.body.appendChild(g); drag.ghost = g;
    if (drag.from != null) { drag.el.classList.add('is-dragging'); ensureTrash().classList.add('show'); }
    document.body.classList.add('cz-dragging');   // bloque la sélection de texte pendant le glissé
  }
  function onDragMove(e) {
    if (!drag) return;
    if (!drag.active) {
      if (Math.abs(e.clientX - drag.x0) + Math.abs(e.clientY - drag.y0) < 8) return;
      beginDrag();
    }
    if (e.cancelable) e.preventDefault();
    _dragX = e.clientX; _dragY = e.clientY;
    if (drag.ghost) drag.ghost.style.transform = 'translate(' + _dragX + 'px,' + _dragY + 'px) translate(-50%,-50%)';   // suivi immédiat du doigt (GPU)
    if (!_dragRaf) _dragRaf = requestAnimationFrame(dragHitTest);   // survol corbeille/emplacements calculé 1×/frame → fluide sur mobile
  }
  function dragHitTest() {
    _dragRaf = 0;
    if (!drag || !drag.active) return;
    clearDropHints();
    var el = targetAt(_dragX, _dragY);
    var t = document.getElementById('czTrash');
    if (drag.from != null && t && el && (el === t || t.contains(el))) { t.classList.add('is-over'); return; }
    var slotEl = el && el.closest ? el.closest('.cz-slot') : null;
    if (slotEl && slotEl.getAttribute('data-idx') !== String(drag.from)) slotEl.classList.add('is-drop');
  }
  function endDrag(e) {
    if (!drag) return;
    unbindDrag();
    if (_dragRaf) { cancelAnimationFrame(_dragRaf); _dragRaf = 0; }
    var d = drag; drag = null;              // on VIDE l'état d'abord (idempotent, ré-entrée sûre) → jamais de blocage
    var dropped = d.active && e && e.type === 'pointerup';   // pointercancel / perte de focus = annulation (pas de dépôt)
    var changed = false;
    try {
      if (dropped) {
        var over = targetAt(e.clientX, e.clientY);
        var slotEl = over && over.closest ? over.closest('.cz-slot') : null;
        var to = slotEl ? parseInt(slotEl.getAttribute('data-idx'), 10) : NaN;
        if (d.palette != null) {                              // depuis la palette → pose
          if (!isNaN(to)) { state.slots[to] = d.palette; lastPlaced = to; changed = true; }
          clearCharmSelection(); paletteDidDrag = true;
          setTimeout(function () { paletteDidDrag = false; }, 350);
        } else {
          var t = document.getElementById('czTrash');
          if (t && over && (over === t || t.contains(over))) { delete state.slots[d.from]; toast('Charm retiré 🗑️'); lastPlaced = -1; changed = true; }
          else if (!isNaN(to) && to !== d.from) {              // échange (ou déplacement si l'emplacement est vide)
            var a = state.slots[d.from], b = state.slots[to];
            state.slots[to] = a;
            if (b != null) state.slots[d.from] = b; else delete state.slots[d.from];
            lastPlaced = -1; changed = true;
          }
        }
      } else if (d.palette == null && !d.active && activeCharm) {   // simple appui + charm sélectionné = remplace
        state.slots[d.from] = activeCharm; clearCharmSelection(); changed = true;
      }
    } catch (err) {}
    if (d.ghost && d.ghost.parentNode) d.ghost.parentNode.removeChild(d.ghost);
    if (d.el && d.el.classList) d.el.classList.remove('is-dragging');
    var tr = document.getElementById('czTrash'); if (tr) tr.classList.remove('show', 'is-over');
    document.body.classList.remove('cz-dragging');
    clearDropHints();
    if (changed || d.active) update();      // re-render seulement si utile (pas à chaque simple clic)
  }
  window.addEventListener('blur', function () { if (drag) endDrag(null); });   // perte de focus en plein glissé → on annule proprement
  document.addEventListener('dragstart', function (e) { if (e.target && e.target.closest && e.target.closest('.charm-img, .charm-chip, .cz-slot, .cz-drag-ghost, .cz-ring')) e.preventDefault(); });   // bloque le glissé natif (Safari)

  /* ---- Rendu de la scène (emplacements + charms posés) ---- */
  /* Repositionne les charms/anneaux/repères EXISTANTS sans reconstruire le DOM (changement de chaîne : mêmes charms, positions différentes).
     Réutilise les <img> déjà décodés → pas de re-décodage → plus de clignotement mobile. Renvoie false si le DOM ne correspond plus (→ rendu complet). */
  function repositionStage() {
    if (!current || loading || (hasColors && !colorChosen)) return false;
    var slots = activeSlots.length ? activeSlots : (current.slots || []);
    var filledByIdx = {}, ringByIdx = {}, emptyByIdx = {}, count = 0;
    Array.prototype.forEach.call(slotsWrap.children, function (ch) {
      if (ch.classList.contains('cz-ring')) { ringByIdx[ch.getAttribute('data-ridx')] = ch; return; }
      var i = ch.getAttribute('data-idx');
      if (ch.classList.contains('cz-slot--filled')) { filledByIdx[i] = ch; count++; }
      else emptyByIdx[i] = ch;
    });
    // le DOM doit correspondre EXACTEMENT aux charms actuels, sinon on retombe sur un rendu complet
    var want = Object.keys(state.slots).length;
    if (count !== want) return false;
    var ok = true;
    slots.forEach(function (s, i) {
      var cid = state.slots[i];
      if (cid) {
        var el = filledByIdx[i];
        if (!el || el.getAttribute('data-cid') !== cid) { ok = false; return; }
        var ringPx = cmToPx(RING_CM);
        var eyY = (s.y / 100) * stage.clientHeight;
        var ringCY = eyY + ringPx * 0.48;
        var charmCY = ringCY + ringPx * 0.40 + charmHpx(cid) / 2;
        el.style.left = s.x + '%';
        el.style.top = (charmCY / stage.clientHeight * 100) + '%';
        var r = ringByIdx[i];
        if (r) { r.style.left = s.x + '%'; r.style.top = (ringCY / stage.clientHeight * 100) + '%'; r.style.width = ringPx + 'px'; }
      } else if (emptyByIdx[i]) {
        emptyByIdx[i].style.left = s.x + '%';
        emptyByIdx[i].style.top = s.y + '%';
      }
    });
    return ok;
  }

  function renderStage() {
    slotsWrap.innerHTML = '';
    if (!current) return;
    if (loading || (hasColors && !colorChosen)) return;   // pas encore chargé / couleur pas choisie → pas de charms
    var slots = activeSlots.length ? activeSlots : (current.slots || []);
    slots.forEach(function (s, i) {
      var el = document.createElement('button');
      el.type = 'button';
      el.setAttribute('data-idx', i);
      el.style.left = s.x + '%';
      if (state.slots[i]) {
        var cid = state.slots[i];
        var eyY = (s.y / 100) * stage.clientHeight;          // œillet, en px
        var ringPx = cmToPx(RING_CM);                        // anneau de jonction 7 mm
        var ringCY = eyY + ringPx * 0.48;                    // l'anneau PEND sous l'œillet (le traverse) : son sommet est au trou, il descend en dessous
        var charmCY = ringCY + ringPx * 0.40 + charmHpx(cid) / 2;   // le charm est accroché dans le BAS de l'anneau, puis pend
        el.style.top = (charmCY / stage.clientHeight * 100) + '%';
        var lx = LOOPX[cid];
        if (lx != null) el.style.setProperty('--tx', (-lx * 100).toFixed(1) + '%');   // aligne la boucle du charm sur l'œillet
        el.className = 'cz-slot cz-slot--filled' + (i === lastPlaced ? ' is-new' : '');
        el.setAttribute('data-cid', cid);                    // pour réutiliser ce nœud au changement de chaîne (pas de re-décodage → pas de clignotement mobile)
        el.innerHTML = charmSvg(cid, { px: charmPx(cid) });   // taille réelle sur le bandana
        el.setAttribute('aria-label', CHARMS[cid].name + ' — maintiens pour déplacer, échanger ou jeter');
        el.style.touchAction = 'none';                      // le glissé tactile ne fait pas défiler la page
        el.addEventListener('pointerdown', function (e) { startCharmDrag(e, i, el); });
        // vraie photo d'anneau de jonction (7 mm), traversant l'œillet
        if (RING_IMG) {
          var ring = document.createElement('img');
          ring.className = 'cz-ring'; ring.src = RING_IMG; ring.alt = '';
          ring.setAttribute('data-ridx', i);                 // apparié à l'emplacement i (repositionnement au changement de chaîne)
          ring.style.left = s.x + '%';
          ring.style.top = (ringCY / stage.clientHeight * 100) + '%';
          ring.style.width = ringPx + 'px';
          slotsWrap.appendChild(ring);
        }
      } else {
        if (current.formulas && Object.keys(state.slots).length >= maxCharms()) return;   // formule pleine → masque les emplacements en trop (pas d'appendChild)
        el.style.top = s.y + '%';                           // marqueur pile sur l'emplacement
        el.className = 'cz-slot' + (current.smallSlots ? ' cz-slot--mini' : '') + (activeCharm ? ' is-active' : '');
        el.innerHTML = '<span class="cz-slot__plus">+</span>';
        el.setAttribute('aria-label', 'Emplacement ' + (i + 1) + ' — ajouter un charm');
        el.addEventListener('click', function () {
          if (!activeCharm) { toast('Choisis d’abord un charm ✨'); return; }
          if (current.formulas && Object.keys(state.slots).length >= maxCharms()) { toast('Formule ' + maxCharms() + ' charms atteinte 💫'); return; }
          state.slots[i] = activeCharm; lastPlaced = i;
          clearCharmSelection();          // la sélection se retire une fois le charm posé
          update();
        });
      }
      slotsWrap.appendChild(el);
    });
    lastPlaced = -1; // consommé : les rendus suivants ne rejouent pas le rebond
  }

  function renderPlaced() {
    var keys = Object.keys(state.slots);
    placedEl.innerHTML = keys.map(function (i) {
      var ch = CHARMS[state.slots[i]];
      return '<div class="placed__item">' + charmSvg(state.slots[i], { cap: '30px' }) +
        '<span class="nm">' + ch.name + '</span><span class="slot">empl. ' + (+i + 1) + '</span>' +
        '<button class="rm" data-rm="' + i + '" aria-label="Retirer ' + ch.name + '"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M18 6 6 18M6 6l12 12"/></svg></button></div>';
    }).join('');
    placedEl.querySelectorAll('[data-rm]').forEach(function (b) {
      b.addEventListener('click', function () { delete state.slots[+b.getAttribute('data-rm')]; lastPlaced = -1; update(); });
    });
    if (countEl && current) countEl.textContent = keys.length + '/' + maxCharms();
  }

  function update() { renderStage(); renderPlaced(); if (typeof updateZoomBtn === 'function') updateZoomBtn(); }

  /* ---- Palette de charms ---- */
  if (charmsWrap) CHARM_ORDER.forEach(function (id) {
    var ch = CHARMS[id];
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'charm-chip';
    b.setAttribute('aria-label', ch.name + ' — taille ' + ch.size);
    b.title = ch.name;
    b.setAttribute('data-color', ch.color || ''); b.setAttribute('data-cats', ch.cats || ''); b.setAttribute('data-size', ch.size || '');
    b.innerHTML = charmSvg(id, { cap: '100%' }) + (ch.size ? '<span class="charm-chip__size">' + ch.size + '</span>' : '');
    b.style.touchAction = 'manipulation';
    // DESKTOP : on peut GLISSER le charm depuis la palette vers un emplacement
    b.addEventListener('pointerdown', function (e) { if (current) startPaletteDrag(e, id, b); });
    b.addEventListener('click', function () {
      if (paletteDidDrag) { paletteDidDrag = false; return; }   // ça vient d'être glissé-posé → pas de sélection
      if (!current) return;
      if (activeCharm === id) { clearCharmSelection(); renderStage(); return; }   // re-clic sur le même charm = désélection
      activeCharm = id;
      charmsWrap.querySelectorAll('.charm-chip').forEach(function (c) { c.classList.remove('is-sel'); });
      b.classList.add('is-sel');
      renderStage();                     // les emplacements libres se mettent à pulser : à toi de choisir OÙ poser
      var hasFree = false;
      for (var i = 0; i < (activeSlots.length || (current.slots || []).length); i++) { if (!state.slots[i]) { hasFree = true; break; } }
      if (!hasFree && !matchMedia('(hover: none)').matches) toast('Tous les emplacements sont pris — retires-en un pour changer 💕');   // pas ce message sur mobile
    });
    charmsWrap.appendChild(b);
  });

  /* ---- Filtres de la palette : univers / couleur / taille ---- */
  function applyFilters() {
    if (!charmsWrap) return;
    var fc = (document.getElementById('czFilterCat') || {}).value || '';
    var fk = (document.getElementById('czFilterColor') || {}).value || '';
    var fs = (document.getElementById('czFilterSize') || {}).value || '';
    var chips = charmsWrap.querySelectorAll('.charm-chip'); var shown = 0;
    for (var i = 0; i < chips.length; i++) {
      var b = chips[i];
      var ok = (!fc || (' ' + (b.getAttribute('data-cats') || '') + ' ').indexOf(' ' + fc + ' ') >= 0)
            && (!fk || b.getAttribute('data-color') === fk)
            && (!fs || b.getAttribute('data-size') === fs);
      b.hidden = !ok; if (ok) shown++;
    }
    var empty = document.getElementById('czNoCharm');
    if (empty) empty.hidden = shown > 0;
  }
  (function buildFilters() {
    if (!charmsWrap) return;
    var cats = {}, colors = {}, sizes = {};
    CHARM_ORDER.forEach(function (id) {
      var c = CHARMS[id];
      (c.cats || '').split(' ').forEach(function (k) { if (k) cats[k] = 1; });
      if (c.color) colors[c.color] = 1;
      if (c.size) sizes[c.size] = 1;
    });
    function sel(id, aria, placeholder, opts) {
      var s = '<select class="cz-filter" id="' + id + '" aria-label="' + aria + '"><option value="">' + placeholder + '</option>';
      opts.forEach(function (o) { s += '<option value="' + o.v + '">' + o.t + '</option>'; });
      return s + '</select>';
    }
    var catOpts = CAT_ORDER.filter(function (k) { return cats[k]; }).map(function (k) { return { v: k, t: CAT_LABELS[k] || k }; });
    var colOpts = COLOR_ORDER.filter(function (k) { return colors[k]; }).map(function (k) { return { v: k, t: k }; });
    var szOpts = SIZE_ORDER.filter(function (k) { return sizes[k]; }).map(function (k) { return { v: k, t: 'Taille ' + k }; });
    var bar = document.createElement('div');
    bar.className = 'cz-filters'; bar.id = 'czFilters';
    bar.innerHTML = sel('czFilterCat', 'Filtrer par univers', 'Univers', catOpts) + sel('czFilterColor', 'Filtrer par couleur', 'Couleur', colOpts) + sel('czFilterSize', 'Filtrer par taille', 'Taille', szOpts);
    charmsWrap.parentNode.insertBefore(bar, charmsWrap);
    var empty = document.createElement('p'); empty.id = 'czNoCharm'; empty.className = 'cz-nocharm'; empty.hidden = true; empty.textContent = 'Aucun charm pour ce filtre 💔';
    charmsWrap.parentNode.insertBefore(empty, charmsWrap.nextSibling);
    bar.addEventListener('change', applyFilters);
  })();

  /* ---- « Voir en grand » : quand tous les charms sont posés, on peut agrandir/zoomer l'aperçu ---- */
  var zoomBtn = document.createElement('button');
  zoomBtn.type = 'button'; zoomBtn.id = 'czZoom'; zoomBtn.className = 'cz-zoom-btn'; zoomBtn.hidden = true;
  zoomBtn.innerHTML = '🔍 Voir ma création en grand';
  if (placedEl && placedEl.parentNode) placedEl.parentNode.insertBefore(zoomBtn, placedEl.nextSibling);
  var zoomModal = document.createElement('div');
  zoomModal.id = 'czZoomModal'; zoomModal.className = 'cz-zoom'; zoomModal.hidden = true;
  zoomModal.innerHTML = '<div class="cz-zoom__bg" data-zclose></div><button class="cz-zoom__x" type="button" data-zclose aria-label="Fermer">✕</button><div class="cz-zoom__box" id="czZoomBox"></div>';
  document.body.appendChild(zoomModal);
  function closeZoom() { zoomModal.hidden = true; document.body.classList.remove('cz-modal-open'); document.getElementById('czZoomBox').innerHTML = ''; }
  function openZoom() {
    var sw = stage.clientWidth, sh = stage.clientHeight; if (!sw || !sh) return;
    var k = Math.min(window.innerWidth * 0.92 / sw, window.innerHeight * 0.85 / sh);   // tient toujours dans l'écran (tête plus haute incluse)
    var clone = stage.cloneNode(true); clone.style.transform = ''; clone.removeAttribute('id'); clone.style.width = sw + 'px'; clone.style.maxWidth = 'none';
    var inner = document.createElement('div'); inner.style.width = sw + 'px'; inner.style.height = sh + 'px';
    inner.style.transform = 'scale(' + k.toFixed(3) + ')'; inner.style.transformOrigin = 'center center'; inner.appendChild(clone);
    var box = document.getElementById('czZoomBox'); box.innerHTML = ''; box.appendChild(inner);
    zoomModal.hidden = false; document.body.classList.add('cz-modal-open');
  }
  zoomBtn.addEventListener('click', openZoom);
  zoomModal.querySelectorAll('[data-zclose]').forEach(function (el) { el.addEventListener('click', closeZoom); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !zoomModal.hidden) closeZoom(); });
  function updateZoomBtn() {
    var tot = maxCharms();
    var n = Object.keys(state.slots).length;
    zoomBtn.hidden = !(current && n > 0 && n >= tot);   // dispo quand TOUS les emplacements sont remplis
  }

  /* ---- Réinitialiser ---- */
  var resetBtn = document.getElementById('czReset');
  if (resetBtn) resetBtn.addEventListener('click', function () {
    state.slots = {}; lastPlaced = -1; clearCharmSelection();
    update();
  });

  /* ---- Ajouter au panier (variante choisie + charms en propriétés) ---- */
  /* Aperçu panier = COMPOSITION (bandana + positions des charms/anneaux en %), PAS une image.
     Reconstruite en HTML dans le panier (de simples <img>) → aucun canvas, donc aucun souci CORS,
     et net à toute taille (miniature ET plein écran). Renvoie l'objet ou null. */
  function captureDesign() {
    try {
      var photo = art.querySelector('img.cz__photo');
      if (!photo) return null;
      var pr = photo.getBoundingClientRect();
      if (!pr.width || !pr.height) return null;
      var pw = photo.naturalWidth || Math.round(pr.width) || 820;
      var ph = photo.naturalHeight || Math.round(pr.height) || 955;
      var out = { b: photo.currentSrc || photo.src, a: pw + '/' + ph, i: [] };   // b=bandana, a=ratio, i=éléments
      var collect = function (sel) {
        var els = stage.querySelectorAll(sel);
        for (var k = 0; k < els.length; k++) {
          var r = els[k].getBoundingClientRect();
          if (!r.width || !r.height) continue;
          out.i.push({
            u: els[k].currentSrc || els[k].src,                                   // url de l'image (affichage seul → pas de CORS)
            x: +(((r.left + r.width / 2) - pr.left) / pr.width * 100).toFixed(2),  // centre X en % du bandana
            y: +(((r.top + r.height / 2) - pr.top) / pr.height * 100).toFixed(2),  // centre Y en %
            w: +((r.width / pr.width * 100).toFixed(2))                            // largeur en % du bandana
          });
        }
      };
      collect('.cz-ring');                        // anneaux d'abord (dessous)
      collect('.cz-slot--filled .charm-img');     // puis charms (au-dessus)
      return out;
    } catch (e) { return null; }
  }

  var addBtn = document.getElementById('czAdd');
  if (addBtn) addBtn.addEventListener('click', function () {
    if (!current) return;
    if (variants[colorIdx] && variants[colorIdx].available === false) { toast('Cette couleur est épuisée pour le moment 💔'); return; }
    var names = Object.keys(state.slots).map(function (i) {
      var slug = state.slots[i], c = CHARMS[slug];
      var ref = (slug + '').replace('charm-', '');                                  // réf unique (= nom de fichier) → identifie SANS ambiguïté un charm de même nom (fiche de correspondance fournie)
      return c.name + ' — taille ' + (c.size || '?') + ', réf ' + ref + ' (empl. ' + (+i + 1) + ')';
    });
    var props = { 'Modèle': current.name };
    if (hasColors && variants[colorIdx]) props[current.variantLabel || 'Couleur'] = variants[colorIdx].color;
    if (current.formulas) props['Formule'] = current.formulas[formulaIdx].n + ' charms (' + money(current.formulas[formulaIdx].price) + ')';
    props['Charms'] = names.length ? names.join(', ') : 'Aucun';
    props['Nombre de charms'] = names.length;
    var colorImg = (variants[colorIdx] && variants[colorIdx].img) || null;
    addBtn.disabled = true;
    toast('Ta création est dans le panier ✨');   // feedback INSTANTANÉ — l'aperçu composé + l'ajout réel se terminent en arrière-plan (plus de délai ressenti)
    if (window.Charmante && Charmante.cart && Charmante.cart.bump) Charmante.cart.bump(1);   // BADGE +1 INSTANTANÉ (optimiste) → plus d'attente réseau ; réconcilié au refresh après l'ajout
    var doAdd = function () {
      var vid = (variants[colorIdx] && variants[colorIdx].id) ? variants[colorIdx].id : (cartVid || null);
      if (current.formulas && shopVariants.length) {   // choisir la variante Shopify au bon PRIX (formule) → facturation correcte
        var target = current.formulas[formulaIdx].price * 100, i, hit = null;
        for (i = 0; i < shopVariants.length; i++) { if (+shopVariants[i].price === target) { hit = shopVariants[i]; break; } }
        vid = (hit && hit.id) || (shopVariants[formulaIdx] && shopVariants[formulaIdx].id) || vid;
      }
      var send = function (id) { return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: id, quantity: 1, properties: props }) }); };
      var flow = vid ? send(vid)
        : fetch('/products/' + current.handle + '.js').then(function (r) { if (!r.ok) throw 0; return r.json(); })
          .then(function (prod) { var v = (prod.variants && prod.variants[0]) || null; if (!v) throw 0; return send(v.id); });
      flow.then(function (r) { if (!r.ok) throw 0;
          if (window.Charmante && Charmante.cart && Charmante.cart.refresh) Charmante.cart.refresh();   // re-fetch /cart.js → met à jour le BADGE du panier (l'ajout se fait en fetch, pas via un formulaire)
          else document.dispatchEvent(new CustomEvent('cart:change')); })
        .catch(function () { toast('Oups, réessaie — crée d’abord le produit « ' + current.name + ' » sur Shopify 💕');
          if (window.Charmante && Charmante.cart && Charmante.cart.refresh) Charmante.cart.refresh(); })   // ajout échoué → recale le badge (annule le +1 optimiste)
        .then(function () { addBtn.disabled = false; });
    };
    // aperçu du panier : on enregistre la COMPOSITION (positions %), reconstruite en HTML côté panier (pas de canvas → pas de CORS). Repli image couleur si rien à composer.
    setTimeout(function () {
      var design = captureDesign();
      if (design && design.i.length) props['_design'] = JSON.stringify(design);
      else if (colorImg) props['_img'] = colorImg;
      doAdd();
    }, 90);   // petit délai : laisser la dernière pose (czPop) se stabiliser
  });

  /* ---- 3D : léger tilt de l'aperçu à la souris (ordinateur uniquement) ---- */
  (function initTilt() {
    if (!window.matchMedia) return;
    if (matchMedia('(prefers-reduced-motion: reduce)').matches || matchMedia('(hover: none)').matches) return;
    var raf = null, tx = 0, ty = 0;
    stage.addEventListener('mousemove', function (e) {
      var r = stage.getBoundingClientRect();
      tx = (e.clientX - r.left) / r.width - 0.5;
      ty = (e.clientY - r.top) / r.height - 0.5;
      if (!raf) raf = requestAnimationFrame(function () {
        raf = null;
        stage.style.transform = 'perspective(760px) rotateX(' + (-ty * 6).toFixed(2) + 'deg) rotateY(' + (tx * 6).toFixed(2) + 'deg)';
      });
    });
    stage.addEventListener('mouseleave', function () { stage.style.transform = ''; });
  })();

  /* ---- Lien direct (#bandana-cou, …) ---- */
  route(true);   // affiche la vue selon l'URL (galerie / produit / idées) sans toucher l'historique
})();
